import React, { useEffect, useRef, useState } from "react";
import { Grid } from "@mui/material";
import "chartjs-plugin-zoom";
import ZoomPlugin from "chartjs-plugin-zoom";
import {
  Chart as ChartJS,
  CategoryScale,
  ArcElement,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
} from "chart.js";
import { Doughnut, Line } from "react-chartjs-2";
import ChevronLeftSharpIcon from "@mui/icons-material/ChevronLeftSharp";
import ChevronRightSharpIcon from "@mui/icons-material/ChevronRightSharp";
import { formatingChart } from "utils/utils";
import { optionsDoughnutCab, options } from "./ChartComponentData";
import Loader from "components/loader/Loader";
import CommonNoDataFound from "components/CommonNoDataFound/CommonNoDataFound";


ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  CategoryScale,
  PointElement,
  ZoomPlugin
);

const ChartComponent = (props) => {
  const [analytics, setAnalytics] = useState({});
  const dashboardRef = useRef(null);

  const totalRegistration =
    props?.tableData?.userTotalRegistration?.userTotalRegistration?.data || {};
  const rideAnalytic =
    props?.tableData?.userRideAnalytic?.userRideAnalytic?.data || {};

  const totalRegistrationLoader =
    props?.tableData?.userTotalRegistration?.loading;
  const rideAnalyticLoader = props?.tableData?.userRideAnalytic?.loading;

  useEffect(() => {
    if (rideAnalytic?.labels && rideAnalytic?.datasets) {
      // const tempFormatingResponse = formatingChart(rideAnalytic);
      const tempFormatingResponse = rideAnalytic;
      setAnalytics(tempFormatingResponse);
    }
  }, [rideAnalytic]);

  const onZoomPluse = () => {
    dashboardRef.current.zoom(1.1);
  };

  const onZoomMinus = () => {
    dashboardRef.current.zoom(0.9);
  };

  const onPanPluse = () => {
    dashboardRef.current.pan({ x: 100 }, undefined, "default");
  };

  const onPanMinus = () => {
    dashboardRef.current.pan({ x: -100 }, undefined, "default");
  };

  const onResetZoom = () => {
    dashboardRef.current.resetZoom();
  };

  return (
    <Grid container item className="chartContainer" gap={2}>
      <Grid
        item
        xs={12}
        sm={12}
        md={3.3}
        sx={{ marginTop: { xs: "10px", sm: "0px" } }}
        className="chartStyle p20"
      >
        {totalRegistrationLoader ? (
          <Loader />
        ) : (
          <>
            {totalRegistration?.labels?.length > 0 ? (
              <Doughnut
                id="doughnutChartCar"
                data={totalRegistration}
                options={optionsDoughnutCab}
                style={{ cursor: "pointer" }}
                plugins={[
                  {
                    beforeDraw(chart) {
                      const { ctx } = chart;
                      const { top, bottom, left, right } = chart.chartArea;
                      ctx.save();
                      const fontSize = 28;
                      ctx.font = `bolder ${fontSize}px sans-serif`;
                      ctx.textAlign = "center";
                      ctx.textBaseline = "end";
                      ctx.fillStyle = "#282828";
                      const text = totalRegistration?.datasets[0]?.data?.reduce(
                        (partialSum, a) => partialSum + a,
                        0
                      );
                      const textX = Math.round((left + right) / 2);
                      const textY = Math.round((top + bottom) / 2);
                      ctx.fillText(text, textX, textY - 15);

                      ctx.font = `10px sans-serif`;
                      const text2 = "Trip";
                      ctx.fillStyle = "#969696";
                      ctx.fillText(text2, textX, textY + 15);
                    },
                  },
                ]}
              />
            ) : (
              <CommonNoDataFound />
            )}
          </>
        )}
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={8.5}
        sx={{ marginTop: { sm: "10px", md: "0px" }, padding: "20px" }}
        className="chartStyle p20"
      >
        {rideAnalyticLoader ? (
          <Loader />
        ) : (
          <>
            <div className="chartWrapper width100 height330">
              <div className="buttonContainer">
                {" "}
                {/* Container for buttons */}
                <button onClick={onResetZoom} className="button">
                  Zoom Reset
                </button>
                <button onClick={onZoomPluse} className="button">
                  Zoom In
                </button>
                <button onClick={onZoomMinus} className="button">
                  Zoom Out
                </button>
              </div>
              <div className="dashboardContainers">
                <ChevronLeftSharpIcon
                  onClick={onPanPluse}
                  className="cursor"
                  disable={analytics?.labels?.length === 0}
                />
                <ChevronRightSharpIcon
                  onClick={onPanMinus}
                  className="cursor"
                />
              </div>
              {analytics?.labels?.length > 0 ? (
                <Line
                  id="barChart"
                  options={options}
                  data={analytics}
                  ref={dashboardRef}
                  style={{ cursor: "pointer" }}
                />
              ) : (
                <CommonNoDataFound />
              )}
            </div>
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default ChartComponent;
